import { ReactNode } from "react";
import { Text } from "@merge-api/merge-javascript-shared";

interface Props {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  // Body padding is opt-in: tables sit flush, prose/grids want padding.
  padBody?: boolean;
}

// A titled section card, mirroring the design's card / card-head / card-body.
const ConductorCard = ({ title, subtitle, actions, children, padBody = false }: Props) => (
  <div className="mb-4 overflow-hidden rounded-lg border border-gray-10 bg-white">
    <div className="flex items-center justify-between gap-3 border-b border-gray-10 px-4 py-3">
      <div className="flex min-w-0 items-baseline gap-2">
        <Text variant="h5">{title}</Text>
        {subtitle && (
          <Text variant="md" className="text-gray-60">
            {subtitle}
          </Text>
        )}
      </div>
      {actions}
    </div>
    <div className={padBody ? "px-4 py-3" : ""}>{children}</div>
  </div>
);

export default ConductorCard;
